module.exports = __webpack_public_path__ + "img/forest.2921f26a.svg";